import {Component, Input} from '@angular/core';
import {KYCStatusResult} from "../../api/entity/kyc-verification";


@Component({
    selector: 'tfl-bo-kyc-status-badge',
    template: `
        <ng-container [ngSwitch]="status">
            <span *ngSwitchCase="statusType.CLEAR" class="label label-success">
                <small *ngIf="explanation" class="explanation">{{ explanation }}</small>
                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.CLEAR' | translate }}
            </span>
            <span *ngSwitchCase="statusType.AML_FOUND" class="label label-danger">
                <small *ngIf="explanation" class="explanation">{{ explanation }}</small>
                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.AML_FOUND' | translate }}
            </span>
            <span *ngSwitchCase="statusType.NOT_VERIFIED" class="label label-default">
                <small *ngIf="explanation" class="explanation">{{ explanation }}</small>
                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.NOT_VERIFIED' | translate }}
            </span>
            <span *ngSwitchCase="statusType.IN_PROGRESS" class="label label-info">
                <small *ngIf="explanation" class="explanation">{{ explanation }}</small>
                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.IN_PROGRESS' | translate }}
            </span>
            <span *ngSwitchCase="statusType.INVALID" class="label label-warning">
                <small *ngIf="explanation" class="explanation">{{ explanation }}</small>
                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.INVALID' | translate }}
            </span>
            <span *ngSwitchCase="statusType.INCOMPLETE_DATA" class="label label-danger">
                <small *ngIf="explanation" class="explanation">{{ explanation }}</small>
                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.INCOMPLETE_DATA' | translate }}
            </span>
        </ng-container>
    `,
    styles: [`
        .explanation {
            color: #ffffff;
        }
    `]
})
export class KYCStatusBadgeComponent {

    @Input() status: KYCStatusResult;
    @Input() explanation: string = null;

    statusType = KYCStatusResult;

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/kyc/kyc.status-badge.component.ts